import { useState } from "react";
import {
  Box,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import theme from "../../../theme/theme";
import { capitalizeFirstLetter } from "../../../utils/strings";
import i18n from "../../../i18n-config";
import {
  CustomAvatar,
  CustomTableFooter,
  StyledTableCell,
  StyledTableRow,
  SvgContainer,
} from "../../../components";
import { MoreVert } from "@mui/icons-material";
import { SORT } from "../../../assets/icons";

const style = {
  fontSize: 14,
  color: theme.colors.black,
  fontWeight: 550,
};

const MenuProps = {
  PaperProps: {
    style: {
      paddingRight: 20,
    },
  },
};

interface Props {
  data: any;
  onDetail: (data: any) => void;
}

function TransactionTable({ data, onDetail }: Props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer
      component={Paper}
      sx={{ mb: 2, boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)" }}
    >
      {data.length ? (
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ bgcolor: "#fff" }}>
              <TableCell sx={style}>#</TableCell>
              <TableCell sx={style}>
                <Stack direction={"row"} alignItems="center">
                  <Typography mr={1}>
                    {capitalizeFirstLetter(i18n.t("date"))}
                  </Typography>
                  <IconButton>
                    <SvgContainer
                      svg={SORT}
                      width={15}
                      color={theme.colors.black}
                    />
                  </IconButton>
                </Stack>
              </TableCell>
              <TableCell sx={style}>
                <Stack direction={"row"}>
                  <SvgContainer
                    svg={SORT}
                    width={15}
                    color={theme.colors.dimgray + "80"}
                  />
                  <Typography ml={1}>
                    {capitalizeFirstLetter(i18n.t("valeur"))}
                  </Typography>
                </Stack>
              </TableCell>
              <TableCell sx={style}>
                <Stack direction={"row"}>
                  <SvgContainer
                    svg={SORT}
                    width={15}
                    color={theme.colors.dimgray + "80"}
                  />
                  <Typography ml={1}>
                    {capitalizeFirstLetter(i18n.t("type"))}
                  </Typography>
                </Stack>
              </TableCell>
              <TableCell sx={style}>
                <Stack direction={"row"}>
                  <SvgContainer
                    svg={SORT}
                    width={15}
                    color={theme.colors.dimgray + "80"}
                  />
                  <Typography ml={1}>
                    {capitalizeFirstLetter(i18n.t("statut"))}
                  </Typography>
                </Stack>
              </TableCell>
              <TableCell sx={style}>
                <Typography>
                  {capitalizeFirstLetter(i18n.t("description"))}
                </Typography>
              </TableCell>
              <TableCell sx={style}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : data
            ).map((item: any, index: any) => (
              <StyledTableRow
                key={index}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  cursor: "pointer",
                }}
              >
                <StyledTableCell>{item.id}</StyledTableCell>
                <StyledTableCell>
                  {new Date(item.dateCreation).toLocaleDateString("en-CA")}{" "}
                </StyledTableCell>
                <StyledTableCell>{item.valeur}</StyledTableCell>
                <StyledTableCell>{i18n.t(item.typeOperation)}</StyledTableCell>
                <StyledTableCell>
                  {i18n.t(item.statutTransaction)}
                </StyledTableCell>
                <StyledTableCell>{item.description}</StyledTableCell>
                <StyledTableCell style={{ width: 40 }}>
                  <Select
                    MenuProps={MenuProps}
                    disableUnderline
                    variant="standard"
                    IconComponent={(props) => (
                      <MoreVert
                        {...props}
                        sx={{ border: "1px solid #EAEAEA", borderRadius: 100 }}
                      />
                      // <MoreOptionICON {...props} />
                    )}
                  >
                    <MenuItem
                      onClick={() => onDetail(item)}
                      style={{
                        background: "white",
                        color: theme.colors.black,
                      }}
                    >
                      {capitalizeFirstLetter(i18n.t("details"))}
                    </MenuItem>
                  </Select>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
          <CustomTableFooter
            rowsPerPage={rowsPerPage}
            data={data}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Table>
      ) : (
        <Box p={15}>
          <Typography textAlign={"center"}>{i18n.t("no_data")}</Typography>
        </Box>
      )}
    </TableContainer>
  );
}

export default TransactionTable;
